import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import { Button, ButtonToolbar, Card, CardBody, Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector, reset } from 'redux-form';
import {
  GROUPS_SUCCESS,
  getGroupsList as getGroupsListAction,
  groupClearState as groupClearStateAction,
  groupClearFlashMessage as groupClearFlashMessageAction,
} from '../../../../redux/actions/groupsAction';
import renderField from '../../../../shared/components/form/TextField';
import renderSelectField from '../../../../shared/components/form/Select';
import DataTable from '../../../../shared/components/data-table';
import { COMPLETED, WAIT } from '../../../../shared/components/data-table/submitStatuses';
import { DATA, ACTION } from '../../../../shared/components/data-table/columnTypes';
import { LINK } from '../../../../shared/components/data-table/buttonTypes';
import { FullWideNotification } from '../../../../shared/components/Notification';
import store from '../../../App/store';

const GroupTable = ({
  getGroupsList,
  groupClearState,
  groupClearFlashMessage,
  showNotification,
  groupsList,
  pagination,
  loadStatus,
  flashMessage,
  resetForm,
}) => {
  const [data, setData] = useState({
    columns: [],
    buttons: [],
    types: [],
    isFind: false,
    status: WAIT,
  });

  const clearFilters = () => {
    resetForm(GroupTable.FORM_NAME);
    setData({ ...data, isFind: true });
  };

  const getConditions = () => {
    const selector = formValueSelector(GroupTable.FORM_NAME);
    return selector(store.getState(), 'name', 'type', 'code');
  };

  const handleFind = () => {
    setData({ ...data, isFind: true });
  };

  const show = (color, message) =>
    showNotification({
      notification: <FullWideNotification color={color} message={message} />,
      position: 'full',
    });

  useEffect(() => {
    if (loadStatus === GROUPS_SUCCESS) {
      setData({ ...data, isFind: false });
    }
  }, [loadStatus]);

  useEffect(() => {
    if (flashMessage && flashMessage.length) {
      setTimeout(() => {
        show('success', flashMessage);
        groupClearFlashMessage();
      }, 1000);
    }
  }, [flashMessage]);

  useEffect(() => {
    const types = [
      {
        value: 'list',
        label: 'Список',
      },
      {
        value: 'sublist',
        label: 'Подсписок',
      },
      {
        value: 'done',
        label: 'Список Выполнено',
      },
      {
        value: 'field',
        label: 'Поле',
      },
      {
        value: 'radio',
        label: 'Переключатели',
      },
      {
        value: 'sentences',
        label: 'Закончить предложения',
      },
      {
        value: 'interview',
        label: 'Массив галочек',
      },
      {
        value: 'mix',
        label: 'Поле с вариантами',
      },
    ];

    const columns = [
      {
        label: '#',
        dbColumn: 'createdAt',
        listColumn: 'number',
        sortable: true,
        width: 5,
        type: DATA,
      },
      {
        label: 'Название группы',
        dbColumn: 'name',
        listColumn: 'name',
        sortable: true,
        width: 30,
        type: DATA,
      },
      {
        label: 'Тип',
        dbColumn: 'type',
        listColumn: 'type',
        sortable: true,
        width: 15,
        type: DATA,
      },
      {
        label: 'Код',
        dbColumn: 'code',
        listColumn: 'code',
        sortable: false,
        width: 35,
        type: DATA,
      },
      {
        label: 'Создан',
        dbColumn: 'createdAt',
        listColumn: 'createdAt',
        sortable: true,
        width: 10,
        type: DATA,
      },
      {
        label: 'Действия',
        dbColumn: '_id',
        listColumn: 'id',
        sortable: false,
        width: 5,
        type: ACTION,
      },
    ];

    const buttons = [
      {
        name: 'edit',
        color: 'primary',
        icon: 'edit',
        type: LINK,
        link: '/groups/',
        text: 'Редактировать',
      },
    ];

    setData({
      ...data,
      columns,
      buttons,
      types,
      status: COMPLETED,
    });

    return () => {
      groupClearState();
    };
  }, []);

  return (
    <Fragment>
      {data.status === COMPLETED && (
        <Fragment>
          <Row>
            <Col md={12} lg={12}>
              <Card>
                <CardBody>
                  <div className="card__title">
                    <h5 className="bold-text">Поиск по группам полей</h5>
                  </div>
                  <form className="form gap-20">
                    <Col className="p-0">
                      <div className="form__form-group">
                        <span className="form__form-group-label">Название группы</span>
                        <div className="form__form-group-field">
                          <Field name="name" component={renderField} type="text" placeholder="Название группы" />
                        </div>
                      </div>
                    </Col>
                    <Col className="p-0">
                      <div className="form__form-group">
                        <span className="form__form-group-label">Код</span>
                        <div className="form__form-group-field">
                          <Field name="code" component={renderField} type="text" placeholder="Код" />
                        </div>
                      </div>
                    </Col>
                    <Col className="p-0">
                      <div className="form__form-group">
                        <span className="form__form-group-label">Тип</span>
                        <div className="form__form-group-field">
                          <Field name="type" component={renderSelectField} placeholder="Тип" options={data.types} />
                        </div>
                      </div>
                    </Col>
                  </form>
                  <ButtonToolbar className="form__button-toolbar wizard__toolbar">
                    <Button color="primary" type="button" onClick={handleFind}>
                      Найти
                    </Button>
                    <Button color="secondary" type="button" onClick={clearFilters}>
                      Очистить
                    </Button>
                  </ButtonToolbar>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md={12} lg={12}>
              <DataTable
                addButton={{ to: '/groups/create', caption: 'Добавить группу полей' }}
                columns={data.columns}
                buttons={data.buttons}
                getConditions={getConditions}
                getList={getGroupsList}
                list={groupsList}
                pagination={pagination}
                isFind={data.isFind}
                loadListStatus={loadStatus}
                declensions={['группа', 'группы', 'групп']}
              />
            </Col>
          </Row>
        </Fragment>
      )}
    </Fragment>
  );
};

GroupTable.FORM_NAME = 'groups_table';

GroupTable.propTypes = {
  getGroupsList: PropTypes.func.isRequired,
  groupClearState: PropTypes.func.isRequired,
  groupClearFlashMessage: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  groupsList: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  // eslint-disable-next-line react/require-default-props
  pagination: PropTypes.objectOf(PropTypes.any),
  loadStatus: PropTypes.string.isRequired,
  flashMessage: PropTypes.string.isRequired,
  resetForm: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  groupsList: state.groups.list,
  pagination: state.groups.pagination,
  loadStatus: state.groups.loadListStatus,
  flashMessage: state.groups.flash,
});

const mapDispatchToProps = (dispatch) => ({
  getGroupsList: (params) => dispatch(getGroupsListAction(params)),
  groupClearState: () => dispatch(groupClearStateAction()),
  groupClearFlashMessage: () => dispatch(groupClearFlashMessageAction()),
  resetForm: (formName) => dispatch(reset(formName)),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps)(withTranslation('common')(withRouter(GroupTable)));

export default reduxForm({
  form: GroupTable.FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(withConnect);
